import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { isNotLoginLogin } from '../../utils/session';

const PrivateRoute = ({ component: Component, ...rest }) => {

  interface TokenInfo {
    exp: number;
  }


  const isLoggedNotIn = isNotLoginLogin();

  return (
    <Route
      {...rest}
      render={props =>
        !isLoggedNotIn ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )
      }
    />
  )
}

export default PrivateRoute